import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    loads: translate({ id: 'global.loads' }),
  }))

  return api
}
